// extracted by mini-css-extract-plugin
export default {"container":"style_container__9ek6p","checkBoxRemember":"style_checkBoxRemember__7MWHj"};